/**
 * @author Daniel Aguirre
 * @file actions.js
 * @description ClinicPhones Actions
 */

// Constants
import {
  GET_CLINIC_PHONES_BY_CLINIC_NAME,
  CREATE_CLINIC_PHONES,
  UPDATE_CLINIC_PHONES,
  GET_CLINIC_PHONES_BY_ID,
  DELETE_CLINIC_PHONES_BY_ID,
  GET_ALL_CLINIC_PHONES
} from './constants';

/**
 * Call process to get all clinic phones list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ALL_CLINIC_PHONES
 */
export const getClinicPhones = (data, callback) => ({
  type: GET_ALL_CLINIC_PHONES,
  payload: { data },
  callback
});

/**
 * Call process to get clinic phones by id
 * @param  { object } data - Clinic Phones Id
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_CLINIC_PHONES_BY_ID
 */
export const getClinicPhonesById = (data, callback) => ({
  type: GET_CLINIC_PHONES_BY_ID,
  payload: { data },
  callback
});

/**
 * Call process to create clinic phones
 * @param  { object } data - Clinic Phones Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of CREATE_CLINIC_PHONES
 */
export const createClinicPhones = (data, callback) => ({
  type: CREATE_CLINIC_PHONES,
  payload: { data },
  callback
});

/**
 * Call process to update clinic phones
 * @param  { object } data - Clinic Phones Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of UPDATE_CLINIC_PHONES
 */
export const updateClinicPhones = (data, callback) => ({
  type: UPDATE_CLINIC_PHONES,
  payload: { data },
  callback
});

/**
 * Call process to delete clinic phones
 * @param  { object } data - Clinic Phones Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of UPDATE_CLINIC_PHONES
 */
export const deleteClinicPhonesById = (data, callback) => ({
  type: DELETE_CLINIC_PHONES_BY_ID,
  payload: { data },
  callback
});

/**
 * Call process to delete clinic phones
 * @param  { object } data - Clinic Phones Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_CLINIC_PHONES_BY_CLINIC_NAME
 */
export const getClinicPhonesByClinicName = (data, callback) => ({
  type: GET_CLINIC_PHONES_BY_CLINIC_NAME,
  payload: { data },
  callback
});
